import { loading, success, failure } from 'utilities/actions'
import * as actions from './actions'
import type { Enrolment } from 'types'

export type State = {
  data: Enrolment[];
  facets: Record<any, any>;
  allFacets: Record<any, any> | null;
  filter: Record<any, any>;
  errors: any[];
  sort: string;
  page: {
    offset: number;
    limit: number;
  };
  total: number;
  loading: boolean;
  dataFetched: boolean;
};

export type Action = any & {
  type: string;
};

export const initalFilterState = {
  page: { offset: 0, limit: 50 },
  filter: {},
  sort: '-created_at'
} as const

export const initialState: State = {
  data: [],
  facets: {},
  allFacets: null,
  errors: [],
  total: 0,
  loading: false,
  dataFetched: false,
  ...initalFilterState
}

const reducer = (state: State, action: Action) => {
  if (state === undefined) { state = initialState }
  switch (action.type) {
    case loading(actions.API_ENROLMENTS_INDEX):
      return { ...state, errors: [], loading: true }
    case success(actions.API_ENROLMENTS_INDEX):
      const { data, meta } = action
      return {
        ...state,
        data,
        total: meta.total,
        loading: false,
        dataFetched: true,
        errors: [],
      }
    case actions.API_ENROLMENTS_FACETS_INDEX_SUCCESS:
      const { data: facets } = action
      if (facets) {
        return {
          ...state,
          facets
        }
      }
      return state
    case actions.API_ENROLMENTS_ALL_FACETS_INDEX:
      return { ...state, allFacets: null }
    case actions.API_ENROLMENTS_ALL_FACETS_INDEX_FAILURE:
      return { ...state, allFacets: {} }
    case actions.API_ENROLMENTS_ALL_FACETS_INDEX_SUCCESS:
      const { data: allFacets } = action
      if (allFacets) {
        return {
          ...state,
          allFacets
        }
      }
      return state
    case failure(actions.API_ENROLMENTS_INDEX):
      return {
        ...state,
        loading: false,
        errors: action.errors.length ? action.errors : ['Failed to load']
      }
    case actions.API_ENROLMENTS_SET_ALL_FILTERS: {
      const { filter, sort, page } = action
      return { ...state, filter, sort, page }
    }

    default:
      return state
  }
}

export default reducer
